import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import flatten from '../data/flattenarray';
import addpath from '../data/addpath';
import filtereddata from '../data/filterUI';
import useAuth from '../features/hooks/useAuth';

const AllContainer = styled.div`
    display: flex;
    flex-basis:auto;
`;

const AllWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: space-around;
    flex-grow: 1;
    row-gap: 50px;
`;

const LinkWrapper = styled.div`
    flex-basis: 30%;
    cursor: pointer;
`;

const OptionContainer = styled.div`
    width:350px;
    display: flex;
    height:150px;
    background-color:#fff;
    /* align-items: center;
    justify-content: center; */
    color: #58548E;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-size: 1.2857142857142856rem;
    line-height: 1.334;
    letter-spacing: 0em;
    margin-left: 24px;
    font-weight: 700;
    position: relative;
    transition: box-shadow 0.3s;
    &:hover{
        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    }
`;

const InnerContainer =styled.div`
    display:flex;
    border-left: 3px solid #955EFF;
    align-items: center;
    position: absolute;
    top: 20%;
    bottom: 20%;
    padding: 25px;
`;

const firstLevelChild = (pathValue, array) => {
    if (pathValue === "home") {
        return array
            .filter(({ title }) => title !== "Home")
            .map(({ title, path }) => ({ title, path }));
    }
    
    for (const val of array) {
        if (val.childrens) {
            if (val.path === pathValue) {
                return val.childrens.map(({ title, path }) => ({ title, path }));
            }
            const result = firstLevelChild(pathValue, val.childrens);
            if (result.length) return result;
        }
    }
    return [];
};      

const Cards = ({ pathValue }) => {
    const [mainArray, setMainArray] = useState([]);
    const navigate = useNavigate();
    const Auth = useAuth();
    const currentOffice = useSelector((state) => state.office.off);
    
    // Memoize the filtered and cloned data to prevent recreation on every render
    const clonedData = useMemo(() => {
        return structuredClone(filtereddata(Auth, currentOffice));
    }, [Auth, currentOffice]);

    useEffect(() => {
        setMainArray(firstLevelChild(pathValue, clonedData));
    }, [pathValue, clonedData]);

    const navigateFunction = (item) => {
        const flatData = flatten(clonedData);
        const targetItem = flatData.find(x => x.path === item.path);
        if (targetItem) {
            const newPath = flatten(addpath(clonedData))?.find(y => y.title === targetItem.title)?.path;
            if (newPath) navigate(`/${newPath}`);
        }
    };

    return (
        <AllContainer>
            <AllWrapper>
                {mainArray?.map((item, index) => (
                    <LinkWrapper key={index} onClick={() => navigateFunction(item)}>
                        <OptionContainer>
                            <InnerContainer>{item.title}</InnerContainer>
                        </OptionContainer>
                    </LinkWrapper>
                ))}
            </AllWrapper>
        </AllContainer>
    );
};

export default Cards;